import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { planAmounts } from '../config/stripePrices';

// ============================================
// LANDING PAGE TRANSLATIONS (existing)
// ============================================
import itLandingCommon from '../pages/landing/locales/it/common.json';
import itHero from '../pages/landing/locales/it/hero.json';
import itHeader from '../pages/landing/locales/it/header.json';
import itFooter from '../pages/landing/locales/it/footer.json';
import itFunctionality from '../pages/landing/locales/it/functionality.json';
import itFaq from '../pages/landing/locales/it/faq.json';
import itPrice from '../pages/landing/locales/it/price.json';
import itStats from '../pages/landing/locales/it/stats.json';
import itVideo from '../pages/landing/locales/it/video.json';
import itMaterial from '../pages/landing/locales/it/material.json';
import itTestimonials from '../pages/landing/locales/it/testimonials.json';
import itAbout from '../pages/landing/locales/it/about.json';
import itFaculty from '../pages/landing/locales/it/faculty.json';
import itLandingAuth from '../pages/landing/locales/it/auth.json';

import enLandingCommon from '../pages/landing/locales/en/common.json';
import enHero from '../pages/landing/locales/en/hero.json';
import enHeader from '../pages/landing/locales/en/header.json';
import enFooter from '../pages/landing/locales/en/footer.json';
import enFunctionality from '../pages/landing/locales/en/functionality.json';
import enFaq from '../pages/landing/locales/en/faq.json';
import enPrice from '../pages/landing/locales/en/price.json';
import enStats from '../pages/landing/locales/en/stats.json';
import enVideo from '../pages/landing/locales/en/video.json';
import enMaterial from '../pages/landing/locales/en/material.json';
import enTestimonials from '../pages/landing/locales/en/testimonials.json';
import enAbout from '../pages/landing/locales/en/about.json';
import enFaculty from '../pages/landing/locales/en/faculty.json';
import enLandingAuth from '../pages/landing/locales/en/auth.json';

import esLandingCommon from '../pages/landing/locales/es/common.json';
import esHero from '../pages/landing/locales/es/hero.json';
import esHeader from '../pages/landing/locales/es/header.json';
import esFooter from '../pages/landing/locales/es/footer.json';
import esFunctionality from '../pages/landing/locales/es/functionality.json';
import esFaq from '../pages/landing/locales/es/faq.json';
import esPrice from '../pages/landing/locales/es/price.json';
import esStats from '../pages/landing/locales/es/stats.json';
import esVideo from '../pages/landing/locales/es/video.json';
import esMaterial from '../pages/landing/locales/es/material.json';
import esTestimonials from '../pages/landing/locales/es/testimonials.json';
import esAbout from '../pages/landing/locales/es/about.json';
import esFaculty from '../pages/landing/locales/es/faculty.json';
import esLandingAuth from '../pages/landing/locales/es/auth.json';

// ============================================
// APP TRANSLATIONS (new global namespaces)
// ============================================
// Italian
import itCommon from '../locales/it/common.json';
import itNavigation from '../locales/it/navigation.json';
import itAuth from '../locales/it/auth.json';
import itProfile from '../locales/it/profile.json';
import itDashboard from '../locales/it/dashboard.json';
import itMaterials from '../locales/it/materials.json';
import itChat from '../locales/it/chat.json';
import itReview from '../locales/it/review.json';
import itUpload from '../locales/it/upload.json';
import itWelcome from '../locales/it/welcome.json';
import itGamification from '../locales/it/gamification.json';
import itErrors from '../locales/it/errors.json';
import itReferral from '../locales/it/referral.json';
import itTeacherDashboard from '../locales/it/teacherDashboard.json';
import itTeacherStudents from '../locales/it/teacherStudents.json';
import itTeacherDetail from '../locales/it/teacherDetail.json';
import itTeacherDocuments from '../locales/it/teacherDocuments.json';
import itMaturita from '../locales/it/maturita.json';
import itHomeV2 from '../locales/it/homeV2.json';
import itNovita from '../locales/it/novita.json';
import itParentDashboard from '../locales/it/parentDashboard.json';
import itPlans from '../locales/it/plans.json';
import itSicurezza from '../locales/it/sicurezza.json';
import itAttivazione from '../locales/it/attivazione.json';

// English
import enCommon from '../locales/en/common.json';
import enNavigation from '../locales/en/navigation.json';
import enAuth from '../locales/en/auth.json';
import enProfile from '../locales/en/profile.json';
import enDashboard from '../locales/en/dashboard.json';
import enMaterials from '../locales/en/materials.json';
import enChat from '../locales/en/chat.json';
import enReview from '../locales/en/review.json';
import enUpload from '../locales/en/upload.json';
import enWelcome from '../locales/en/welcome.json';
import enGamification from '../locales/en/gamification.json';
import enErrors from '../locales/en/errors.json';
import enReferral from '../locales/en/referral.json';
import enTeacherDashboard from '../locales/en/teacherDashboard.json';
import enTeacherStudents from '../locales/en/teacherStudents.json';
import enTeacherDetail from '../locales/en/teacherDetail.json';
import enTeacherDocuments from '../locales/en/teacherDocuments.json';
import enHomeV2 from '../locales/en/homeV2.json';
import enNovita from '../locales/en/novita.json';
import enParentDashboard from '../locales/en/parentDashboard.json';
import enPlans from '../locales/en/plans.json';
import enSicurezza from '../locales/en/sicurezza.json';
import enAttivazione from '../locales/en/attivazione.json';

// Spanish
import esCommon from '../locales/es/common.json';
import esNavigation from '../locales/es/navigation.json';
import esAuth from '../locales/es/auth.json';
import esProfile from '../locales/es/profile.json';
import esDashboard from '../locales/es/dashboard.json';
import esMaterials from '../locales/es/materials.json';
import esChat from '../locales/es/chat.json';
import esReview from '../locales/es/review.json';
import esUpload from '../locales/es/upload.json';
import esWelcome from '../locales/es/welcome.json';
import esGamification from '../locales/es/gamification.json';
import esErrors from '../locales/es/errors.json';
import esReferral from '../locales/es/referral.json';
import esTeacherDashboard from '../locales/es/teacherDashboard.json';
import esTeacherStudents from '../locales/es/teacherStudents.json';
import esTeacherDetail from '../locales/es/teacherDetail.json';
import esTeacherDocuments from '../locales/es/teacherDocuments.json';
import esHomeV2 from '../locales/es/homeV2.json';
import esNovita from '../locales/es/novita.json';
import esParentDashboard from '../locales/es/parentDashboard.json';
import esPlans from '../locales/es/plans.json';
import esSicurezza from '../locales/es/sicurezza.json';
import esAttivazione from '../locales/es/attivazione.json';

// ============================================
// MIGRATION FOR EXISTING USERS
// ============================================
const migrateOldLanguagePreference = () => {
  const oldKey = 'preferredLanguage';
  const newKey = 'i18nextLng';
  
  try {
    const oldValue = localStorage.getItem(oldKey);
    const newValue = localStorage.getItem(newKey);
    
    if (oldValue && !newValue) {
      localStorage.setItem(newKey, oldValue);
    }
  } catch (error) {
    console.error('Error migrating language preference:', error);
  }
};

migrateOldLanguagePreference();

// ============================================
// RESOURCES CONFIGURATION
// ============================================
// Cifre di listino esposte a TUTTE le stringhe i18n (vedi `defaultVariables`).
// Nomi espliciti e non ambigui: la frase deve dire cosa sta stampando.
const priceVars = () => {
  const m = planAmounts('monthly');
  const t3 = planAmounts('trimonthly');
  const sc = planAmounts('annualSchool');
  const un = planAmounts('annualUniversity');
  return {
    prezzoMensile: m?.cost,
    prezzo3Mesi: t3?.cost,
    mensile3Mesi: t3?.perMonth,
    sconto3Mesi: t3?.savingPercent,
    prezzoAnnoScolastico: sc?.cost,
    mensileAnnoScolastico: sc?.perMonth,
    scontoAnnoScolastico: sc?.savingPercent,
    prezzo12Mesi: un?.cost,
    mensile12Mesi: un?.perMonth,
    sconto12Mesi: un?.savingPercent,
  };
};

const resources = {
  it: {
    // Landing page namespaces (prefixed with 'landing')
    landingCommon: itLandingCommon,
    hero: itHero,
    header: itHeader,
    footer: itFooter,
    functionality: itFunctionality,
    faq: itFaq,
    price: itPrice,
    stats: itStats,
    video: itVideo,
    material: itMaterial,
    testimonials: itTestimonials,
    about: itAbout,
    faculty: itFaculty,
    landingAuth: itLandingAuth,
    // App namespaces
    common: itCommon,
    navigation: itNavigation,
    auth: itAuth,
    profile: itProfile,
    dashboard: itDashboard,
    materials: itMaterials,
    chat: itChat,
    review: itReview,
    upload: itUpload,
    welcome: itWelcome,
    gamification: itGamification,
    errors: itErrors,
    referral: itReferral,
    teacherDashboard: itTeacherDashboard,
    teacherStudents: itTeacherStudents,
    teacherDetail: itTeacherDetail,
    teacherDocuments: itTeacherDocuments,
    maturita: itMaturita,
    homeV2: itHomeV2,
    novita: itNovita,
    parentDashboard: itParentDashboard,
    plans: itPlans,
    sicurezza: itSicurezza,
    attivazione: itAttivazione
  },
  en: {
    // Landing page namespaces
    landingCommon: enLandingCommon,
    hero: enHero,
    header: enHeader,
    footer: enFooter,
    functionality: enFunctionality,
    faq: enFaq,
    price: enPrice,
    stats: enStats,
    video: enVideo,
    material: enMaterial,
    testimonials: enTestimonials,
    about: enAbout,
    faculty: enFaculty,
    landingAuth: enLandingAuth,
    // App namespaces
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    profile: enProfile,
    dashboard: enDashboard,
    materials: enMaterials,
    chat: enChat,
    review: enReview,
    upload: enUpload,
    welcome: enWelcome,
    gamification: enGamification,
    errors: enErrors,
    referral: enReferral,
    teacherDashboard: enTeacherDashboard,
    teacherStudents: enTeacherStudents,
    teacherDetail: enTeacherDetail,
    teacherDocuments: enTeacherDocuments,
    homeV2: enHomeV2,
    novita: enNovita,
    parentDashboard: enParentDashboard,
    plans: enPlans,
    sicurezza: enSicurezza,
    attivazione: enAttivazione
  },
  es: {
    // Landing page namespaces
    landingCommon: esLandingCommon,
    hero: esHero,
    header: esHeader,
    footer: esFooter,
    functionality: esFunctionality,
    faq: esFaq,
    price: esPrice,
    stats: esStats,
    video: esVideo,
    material: esMaterial,
    testimonials: esTestimonials,
    about: esAbout,
    faculty: esFaculty,
    landingAuth: esLandingAuth,
    // App namespaces
    common: esCommon,
    navigation: esNavigation,
    auth: esAuth,
    profile: esProfile,
    dashboard: esDashboard,
    materials: esMaterials,
    chat: esChat,
    review: esReview,
    upload: esUpload,
    welcome: esWelcome,
    gamification: esGamification,
    errors: esErrors,
    referral: esReferral,
    teacherDashboard: esTeacherDashboard,
    teacherStudents: esTeacherStudents,
    teacherDetail: esTeacherDetail,
    teacherDocuments: esTeacherDocuments,
    homeV2: esHomeV2,
    novita: esNovita,
    parentDashboard: esParentDashboard,
    plans: esPlans,
    sicurezza: esSicurezza,
    attivazione: esAttivazione
  }
};

// ============================================
// NAMESPACE LISTS
// ============================================
const landingNamespaces = [
  'landingCommon', 'hero', 'header', 'footer', 'functionality', 
  'faq', 'price', 'stats', 'video', 'material', 'testimonials', 
  'about', 'faculty', 'landingAuth'
];

const appNamespaces = [
  'common', 'navigation', 'auth', 'profile', 'dashboard',
  'materials', 'chat', 'review', 'upload', 'welcome',
  'gamification', 'errors', 'referral', 'teacherDashboard',
  'teacherStudents', 'teacherDetail', 'teacherDocuments',
  'maturita', 'homeV2', 'parentDashboard', 'novita',
  // 'plans' e' il namespace di SummerOfferModal (STU-66). Il componente e' andato
  // in produzione a luglio senza il suo file di stringhe e senza questa riga:
  // chi provava a disdire da un piano mensile si trovava davanti le CHIAVI
  // ("summerPause.headline"), cioe' l'offerta di pausa illeggibile proprio nel
  // momento in cui stava decidendo se restare.
  'plans',
  // 'sicurezza': la pagina /sicurezza, il blocco in home e la voce dell'header
  // (STU-479). Senza questa riga si vedrebbero le chiavi, come per 'plans'.
  'sicurezza',
  // 'attivazione': i blocchi guidati dal server (STU-520), come la carta
  // «Prova subito StudierAI» in home e l'invito dopo la prima risposta.
  'attivazione'
];

// ============================================
// SUPPORTED LANGUAGES
// ============================================
export const supportedLanguages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

// ============================================
// i18n INITIALIZATION
// ============================================
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    defaultNS: 'common',
    ns: [...landingNamespaces, ...appNamespaces],
    
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode']
    },

    interpolation: {
      escapeValue: false,
      // Le cifre di listino arrivano da UNA fonte sola (@config/stripePrices,
      // che le tiene accanto ai price id, per ambiente). Iniettarle qui come
      // variabili di default significa che ogni stringa puo' scrivere
      // {{prezzo3Mesi}} senza che il punto di chiamata debba passare niente:
      // un t() dimenticato mostrerebbe "{{prezzo3Mesi}}" a un utente pagante.
      //
      // Perche' serve: preprod addebita i price del TEST mode, produzione quelli
      // live. Con le cifre scritte a mano dentro le frasi, cambiare listino da
      // una parte sola faceva dire alla pagina un prezzo e addebitare l'altro.
      defaultVariables: priceVars(),
    },

    react: {
      useSuspense: false
    }
  });

// Tiene <html lang> sincronizzato con la lingua attiva (a11y + SEO):
// index.html parte con lang="it" (fallbackLng), qui si allinea al detect
// e ai cambi runtime. Guard su document per ambienti senza DOM (SSR/test).
const syncDocumentLang = (lng) => {
  if (typeof document !== 'undefined' && lng) {
    document.documentElement.lang = lng;
  }
};

i18n.on('languageChanged', syncDocumentLang);
// Allinea subito: l'evento iniziale puo' essere gia' partito durante init()
syncDocumentLang(i18n.resolvedLanguage || i18n.language);

// Esponi i18n su window per accesso diretto nei test E2E (Cypress)
if (typeof window !== 'undefined') {
  window.__i18n = i18n;
}

export default i18n;

